import { FRAME_THEME_COLOR, MARKET } from '@nandosaus/constants';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { BackgroundFrame } from '../../components/frames/background-frame';
import { Col, Container, Row } from '../../components/grid';
import { Layout } from '../../components/layout';
import { navigation } from '../../constants';
import { PageReturnLink } from '../../components/page-return-link';
import { SignInForm } from '../../components/sign-in-form';
import { useRedirectIfAuthenticated } from '../../hooks/useRedirectIfAuthenticated';

const SignIn = ({ title }) => {
  useRedirectIfAuthenticated();
  const { MemberStore, AuthStore } = useRootStore();

  const router = useRouter();
  const { afterSignUp } = router.query;

  const { TEAL } = FRAME_THEME_COLOR;

  return (
    <Layout title={title}>
      <BackgroundFrame showFireIcon showTopBar={false} variant={TEAL}>
        <Container flex={1}>
          {MemberStore.profile && !MemberStore.profile.mobile && (
            <PageReturnLink
              navigationLink={navigation.SIGN_IN}
              linkText="Back to sign in"
              onClick={AuthStore.signOut}
            />
          )}
          <Row mt={MemberStore.profile ? 2 : 4} mb={MemberStore.profile ? 1.5 : 3}>
            <Col width={{ xs: 12 / 12, lg: 6 / 12 }} offset={[0, 0, 0, 3 / 12]}>
              <SignInForm showAlert={afterSignUp === 'true'} />
            </Col>
          </Row>
        </Container>
      </BackgroundFrame>
    </Layout>
  );
};

SignIn.propTypes = {
  title: PropTypes.string,
};

SignIn.defaultProps = {
  title: undefined,
};

export function getStaticProps() {
  const isAusMarket = process.env.market === MARKET.AUSTRALIA;
  return {
    props: {
      title: isAusMarket
        ? 'Sign In | Login to your Nando’s Account'
        : 'Nando’s New Zealand Account Log In | PERi-Perks and Ordering',
    },
  };
}

export default observer(SignIn);
